import styled from "styled-components";

/**
 * Estilo do componente AdBanner.
 *
 * Configura estilização dinâmica com base nas props fornecidas.
 */
export const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing(4)};
  width: -webkit-fill-available;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  display: flex;
  align-self: center;
  display: flex;
`;
